import {
    DeloitteLogo,
    AdobeLogo,
    JPMorganLogo,
    nasalogo,
    PWCLogo,
    RippleMatchLogo,
    SAPLogo,
    CiscoLogo,
    TakenakaPartnersLogo,
    SiemensLogo,
    AmazonLogo,
    KumonLogo,
    KimleyHornLogo,
    ConcordiaLogo,
    ExperianLogo,
    WiseAssistantLogo,
    HORLogo,
    GitHubLogo,
    YouTubeLogo,
    LoroPianaLogo,
    USAALogo,
    BlackrockLogo,
    MeetTheFlockersLogo,
    CapitalGroupLogo,
    BrenLogo,
    RaytheonLogo,
    GlobalFoundriesLogo,
    KaiserPermanenteLogo,
    ACCLogo,
    AmplifySurgicalLogo,
    BachemLogo,
    BioRadLogo,
    CopilotLogo,
    FlowspaceLogo,
    PartifulLogo,
    RadixLogo,
    SBSLogo,
    SkylarLogo,
    ReitLogo,
    PurpleLogo,
    JobrightLogo,
    FritoLayLogo,
    BiologicalSciencesLogo,
    UCIAthleticsLogo
  } from "../Assets";
  import DefaultHeadshot from "./ActiveHeadshots/Default Headshot.webp";
  

export const companyHash = {
    "Aarush Inamdar": AdobeLogo,
    "Alex Kao": JPMorganLogo,
    "Sarah Kim": KumonLogo,
    "Yan Amy Zhou": JPMorganLogo,
    "Anna Shan": BlackrockLogo,
    "Mason Whang": LoroPianaLogo, 
    "Andrew Sou": BrenLogo,
    "Annie Nguyen": SAPLogo,
    "Alexis Lin": AmazonLogo,
    "Catelynn Chen": SkylarLogo,
    "Elle Hsu": PurpleLogo,
    "Anuj Patel": nasalogo,
    "Andrew Hauber": CapitalGroupLogo,
    "Allen Lai": CiscoLogo,
    "Cindy Chen": BiologicalSciencesLogo,
    "Daniel Kim": TakenakaPartnersLogo,
    "Donny Chau": GlobalFoundriesLogo,
    "Katie Wang": GitHubLogo,
    "Lauren Cho": RaytheonLogo,
    "Max Vano": SiemensLogo,
    "Pranay Macherla": AmazonLogo,
    "Mina Nguyen": KaiserPermanenteLogo,
    "Tommy Nguyen": MeetTheFlockersLogo,
    "Alex Sriprathum": KimleyHornLogo,
    "Nico Simonian": USAALogo,
    "Carl Qiao": PWCLogo,
    "Logan Kim": ConcordiaLogo,
    "Ryan Park": ExperianLogo,
    "Melinda Do": WiseAssistantLogo,
    "Travis Yen": JobrightLogo,
    "Tyler Ho": DeloitteLogo,
    "Erin Tran": ReitLogo,
    "Bradly Ho": HORLogo,
    "Brandon Koh": YouTubeLogo,
    "David Kim": BachemLogo,
    "Ashley Kang": PartifulLogo,
    "Millicent Mei": FritoLayLogo,
    "Brandon Peng": ACCLogo,
    "Nicole Kwan": CopilotLogo,
    "Ashlyn Wong": FlowspaceLogo,
    "Gabrielle Reyes": UCIAthleticsLogo,
    "Grace Ryu": RadixLogo,
    "Samantha Lee": AmplifySurgicalLogo,
    "Henry Lee": SBSLogo,
    "Rishi Murumkar": BioRadLogo,
    "Izella Han": RippleMatchLogo,
    "Default Headshot": DefaultHeadshot,
  };
    